import Component from '../../../lib/component';
import template from './editor.html';
import './editor.scss';

let WangEditor;
try{
    WangEditor = require('wangeditor');
} catch (err) {
    console.log(err)
}

// let toolbarOption = [
//     ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
//     ['link', 'image'],
//     ['blockquote', 'code-block'],
//     [{'align': []}],
//
//     [{'header': 1}, {'header': 2}],               // custom button values
//     [{'list': 'ordered'}, {'list': 'bullet'}],
//     // [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
//     // [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
//     [{'direction': 'rtl'}],                         // text direction
//
//     // [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
//     [{'header': [1, 2, 3, 4, 5, 6, false]}],
//
//     [{'color': []}, {'background': []}],          // dropdown with defaults from theme
//     // [{'font': []}],
//
//
//     // ['clean']
//
// ];

let config = {
    template: template,
    binds:[
        {
            event: 'click',
            selector: '.ui-history',
            callback: function(){
                this.events.emitHistory(this.data)
            }
        },
    ],
    data: {},
    actions: {
        publishMessage: function () {
            this.data.value = this.wangEditor.txt.html();
            this.events.changeValue(this.data);
        }
    },
    afterRender: function () {
        let editWrap = this.el.find('.content .editor');
        this.wangEditor = new WangEditor(editWrap[0]);
        this.wangEditor.customConfig.zIndex = 1;
        if (this.data.is_view) {
            this.el.find('.wrap .editor .w-e-text-container').attr('title', this.data.value.replace(/<.*?>/ig,""))
        }
        if(this.data.history && !this.data.isApproval){
            this.el.find('.ui-history').css('visibility','visible');
        }
        this.wangEditor.customConfig.uploadImgShowBase64 = true;
        this.wangEditor.customConfig.showLinkImg = false;
        this.wangEditor.customConfig.onchange = _.debounce(() => {
            this.actions.publishMessage();
        }, 1000);
        // 自定义处理粘贴的文本内容,解决粘贴word出现多的代码<!--[if gte mso 9]><xml></xml><![endif]-->
        this.wangEditor.customConfig.pasteTextHandle = function (content) {
            // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
            if (content == '' && !content) return ''
            let str = content;
            str = str.replace(/<xml>[\s\S]*?<\/xml>/ig, '');
            str=str.replace('/(\\n|\\r| class=(")?Mso[a-zA-Z]+(")?)/g','');
            let reg=new RegExp('<!--(.*?)-->','g')
            str=str.replace(reg,'');
            return str
        }
        this.wangEditor.create();
        //如果内容不为空，则设置初始内容
        if(this.data.value){
            this.wangEditor.txt.html('<p>' + this.data.value + '</p>');
        }
        //查看模式禁用编辑功能
        if(this.data.is_view == 1){
            this.wangEditor.$textElem.attr('contenteditable', false);
        }else{
            this.wangEditor.$textElem.attr('contenteditable', true);
        }
        this.el.find('.w-e-text').blur();
    },
    beforeDestory: function () {
        this.wangEditor = null;
    }
};

let EditorControl = Component.extend(config);
export default EditorControl;



// WEBPACK FOOTER //
// app/components/form/editor-control/editor.js